<template>
  <div class="notice-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           stripe
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 创建祝福 弹层 -->
    <Modal v-model="showCreatTypeModal"
           title="添加"
           @on-ok="createType()"
           :loading="loading">
      <Form :model="cate"
            action="javascript:void(0)">
        <FormItem label="姓名">
          <Input v-model="cate.name"
                 placeholder />
        </FormItem>
        <FormItem label="手机号">
          <Input v-model="cate.phone"
                 placeholder />
        </FormItem>
        <FormItem label="管理区域">
          <Input v-model="cate.describe"
                 placeholder />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
  
  <script>
export default {
  name: "notice-list",
  data () {
    return {
      loading: true,
      dataloading: true,
      cate: {
        name: "",
        phone: "",
        describe: "",
      },
      formItem: {},
      tablelist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "姓名",
          minWidth: 300,
          key: "name",
        },
        {
          title: "手机号",
          minWidth: 300,
          key: "phone",
        },
        {
          title: "管理区域",
          minWidth: 300,
          key: "describe",
        },
        {
          title: "状态",
          key: "status",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.status // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 130,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editType(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeType(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      showCreatTypeModal: false,
      currentId: 0 // 编辑，当前id
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {},
  methods: {
    // 获取产品列表
    getTableList: function () {
      var self = this;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.baixingqiangoperator.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    addGoodCate: function () {
      this.showCreatTypeModal = true;
      this.currentId = 0;
      this.cate.content = "";
    },
    // 编辑
    editType: function (id) {
      this.currentId = id;
      this.showCreatTypeModal = true;
      this.$api.baixingqiangoperator.detail({ id: id }).then(res => {
        if (res.code == 200) {
          this.cate = res.result;
        }
      });
    },
    // 提交祝福
    createType: function (name) {
      let params = {
        name: this.cate.name,
        phone: this.cate.phone,
        describe: this.cate.describe,
      };
      if (
        this.currentId == null ||
        this.currentId == 0 ||
        this.currentId == ""
      ) {
        this.$api.baixingqiangoperator.create(params).then(res => {
          if (res.code == 200) {
            this.showCreatTypeModal = false;
            this.getTableList();
          }
        });
      } else {
        params.id = this.currentId;
        this.$api.baixingqiangoperator.edit(params).then(res => {
          if (res.code == 200) {
            this.showCreatTypeModal = false;
            this.getTableList();
          }
        });
      }
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
      this.showCreatTypeModal = false;
    },
    // 删除
    removeType: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>是否确定删除该？</p>",
        onOk: () => {
          this.$api.baixingqiangoperator
            .remove({
              id: id
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key
      };
      this.$api.baixingqiangoperator.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.baixingqiangoperator.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        } else {
          this.getTableList();
        }
      });
    }
  }
};
  </script>
  
  
